import { render, staticRenderFns } from "./FuncaoView.vue?vue&type=template&id=d3a4e6a8&"
import script from "./FuncaoView.vue?vue&type=script&lang=js&"
export * from "./FuncaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports